import GetSweepRulesJsonRequest from 'owa-service/lib/contract/GetSweepRulesJsonRequest';
import GetSweepRulesJsonResponse from 'owa-service/lib/contract/GetSweepRulesJsonResponse';
import getSweepRulesRequest from 'owa-service/lib/factory/getSweepRulesRequest';
import getSweepRulesJsonRequest from 'owa-service/lib/factory/getSweepRulesJsonRequest';
import getSweepRulesOperation from 'owa-service/lib/operation/getSweepRulesOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Helper method that creates the GetSweepRulesJsonRequest body
 * @return GetSweepRulesJsonRequest
 */
function createRequestBody(): GetSweepRulesJsonRequest {
    const body = getSweepRulesRequest(null);
    return getSweepRulesJsonRequest({ Header: getJsonRequestHeader(), Body: body });
}

/**
 * Get sweep rules service
 * @return the GetSweepRuleResponse
 */
export default function getSweepRulesService(): Promise<GetSweepRulesJsonResponse> {
    let requestBody = createRequestBody();
    return getSweepRulesOperation(requestBody);
}
